import { LoyaltyBalance } from '@/types/loyalty-balance';
import api from '@/utils/api';

export const getLoyaltyBalance = (): Promise<LoyaltyBalance> =>
  api.get('/loyalty_balance', {
    next: {
      revalidate: 0,
    },
  });
